import React from 'react';
import ReactDOM from 'react-dom';
import Modal from './modal_normal';
import ModalAlert from './modal_alert';

const show_dialog = props => {
    // console.log(props);
    let component = null;
    let div = null;

    if (document.querySelector('#modal_root')) {
        div = document.querySelector('#modal_root');
    } else {
        div = document.createElement('div');
        document.querySelector('#root').appendChild(div);

        div.id = 'modal_root';
        div.classList.add('modal_root');
    }

    const modal = document.createElement('div');

    modal.id = `modal_${new Date().getTime()}`;

    modal.style.width = '100%';
    modal.style.height = `${document.documentElement.clientHeight}px`;

    div.appendChild(modal);

    const onClose = () => {
        ReactDOM.unmountComponentAtNode(modal);
        div.removeChild(modal);
        if (typeof props.onClose === 'function') {
            props.onClose();
        }
    };

    ReactDOM.render(
        /* eslint-disable */
        <Modal {...props} onClose={onClose} ref={c => (component = c)} isOpen>
            {props.content}
        </Modal> /* eslint-enable */,
        modal,
    );
};

const show_alert = props => {
    // console.log(props);
    let component = null;
    let div = null;

    if (document.querySelector('#modal_root')) {
        div = document.querySelector('#modal_root');
    } else {
        div = document.createElement('div');
        document.querySelector('#root').appendChild(div);

        div.id = 'modal_root';
        div.classList.add('modal_root');
    }

    const modal = document.createElement('div');

    modal.id = `modal_alert_${new Date().getTime()}`;

    modal.style.width = '100%';
    modal.style.height = `${document.documentElement.clientHeight}px`;

    div.appendChild(modal);

    const onClose = () => {
        ReactDOM.unmountComponentAtNode(modal);
        div.removeChild(modal);
        if (typeof props.onClose === 'function') {
            props.onClose();
        }
    };

    ReactDOM.render(
        /* eslint-disable */
        <ModalAlert {...props} onClose={onClose} ref={c => (component = c)} isOpen>
            {props.content}
        </ModalAlert> /* eslint-enable */,
        modal,
    );
};

const Dialog = {
    show: props =>
        show_dialog({
            ...props,
        }),
};

const Alert = {
    show: props =>
        show_alert({
            ...props,
        }),
};

export { Modal, Dialog, Alert };
